export default Boolean(process?.versions?.node);
